var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M4.66534 14.0027H3.99839C2.89336 14.0027 1.99756 13.1069 1.99756 12.0019V11.335",
    stroke: "#3485FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M11.3347 1.99805H12.0017C13.1067 1.99805 14.0025 2.89385 14.0025 3.99888V4.66582",
    stroke: "#3485FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M1.99756 4.66582V3.99888C1.99756 2.89385 2.89336 1.99805 3.99839 1.99805H4.66534",
    stroke: "#3485FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    d: "M14.0025 11.335V12.0019C14.0025 13.1069 13.1067 14.0027 12.0017 14.0027H11.3347",
    stroke: "#3485FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.75766 11.0328L10.6371 5.96404C10.6974 5.79428 10.6547 5.60496 10.5273 5.47757C10.3999 5.35018 10.2106 5.30746 10.0409 5.36779L4.97208 7.24791C4.78357 7.32037 4.66302 7.50584 4.67334 7.70754C4.68366 7.90924 4.82251 8.08143 5.01743 8.13428L7.30239 8.70851L7.87262 10.9861C7.92581 11.1802 8.09735 11.3183 8.29829 11.3289C8.49923 11.3395 8.68435 11.2202 8.75766 11.0328V11.0328Z",
    stroke: "#3485FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.31a225cb20597187457cd55b6bf76909.svg";
export { ForwardRef as ReactComponent };